import React,{useState, useEffect}  from 'react';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csoops(){

    const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
        <Sides/>
        <Helmet>
 
 <title>C# oops tutorial For Beginners</title>
 <meta name="description" content="C# oops tutorial for beginners.oops in C# is a collection of similar type of data and stored in manually consecutively under one name CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# oops,c# oops for,c sharp oops,Object oriented Programming Language in C#,oops tutorial for Begineers in C#" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-oops" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1"> CSharp object-oriented programming (oops)</h1>
    <div className="first">
        <a href="/csharp-array">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-class-object">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para">
1, C# object-oriented programming (oops) concepts in c#<br/>
2, Object-oriented programming in c# is a programming  methodology, paradigm or style<br/>
</p>
<h2 className="mt-4 mh2">There are 6 main oops concepts in c#:
</h2>
<h3 className="mt-4 mh3">
1, Class<br/>
2, Object and method<br/>
3, Inheritance<br/>
4, Abstraction<br/>
5, Polymorphism<br/>
6, Encapsulation<br/>
</h3>


  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/csharp-array">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-class-object">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>

        </div>
    </div>
)

}
export default Csoops;